import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './services/settings.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'mpf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private translate: TranslateService, private settings: SettingsService) {}

  ngOnInit() {
    console.log('Running version: ', environment.version);
    localStorage.setItem('version', environment.version);
    const defaultLang = 'de';
    this.translate.setDefaultLang(defaultLang);

    let lang = defaultLang;

    const returningUser = localStorage.getItem('returningUser');

    if (returningUser === 'true') {
      lang = this.settings.getLanguage();
    } else {
      localStorage.setItem('returningUser', 'true');
    }

    this.settings.setLanguage(lang);
    this.translate.use(lang);
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/app.component.ts